export default "__VITE_ASSET__231eb832__"